import React from 'react';
import styled from 'styled-components';
import UserProfileDropDown from '../UserProfileDropDown';
import Logo from '../../assets/images/emircomLogo.png';
import { NotificationIcon } from 'app/assets/icons';
import { NotificationDropDownComponent } from '../NotificationDropDownComponent';
import { useNavigateToRoute } from 'utils/common';
import { useNotificationApi } from 'app/hooks/useNotificationApi';
import Cookies from 'js-cookie';

interface Props {
  isMobileView?: boolean;
}
const NavBar = ({ isMobileView }: Props) => {
  const userDetails = JSON.parse(Cookies.get('userDetails') || '{}');
  const isRefetch = Cookies.get('isRefetchNotification') === 'true';
  const { useGetNotifications } = useNotificationApi();
  const { data: notificationList, refetch } = useGetNotifications();
  const { useMarkAllRead } = useNotificationApi();
  const reFetchAfterRead = () => {
    refetch();
  };
  const markAllReadMutation = useMarkAllRead(
    {
      viewedNotifications: null,
      option: 'MarkAllAsRead',
    },
    reFetchAfterRead,
  );
  const redirect = useNavigateToRoute();
  const [isOpenNotification, setIsOpenNotification] =
    React.useState<boolean>(false);
  const [isAnyNotification, setIsAnyNotification] =
    React.useState<boolean>(true);
  const onMarkAllAsRead = () => {
    markAllReadMutation.mutate();
  };
  const pathname = window.location.pathname;
  const windowWidth = window.innerWidth;

  const userName =
    (userDetails?.firstName ?? '') + ' ' + (userDetails?.lastName ?? '');
  React.useEffect(() => {
    if (isRefetch) {
      refetch();
      Cookies.remove('isRefetchNotification');
      setIsAnyNotification(true);
    }
  }, [isRefetch]);
  return (
    <Wrapper className="nav-wrapper">
      <ImageWrapper>
        <img
          className="logo-img"
          style={{ cursor: 'pointer' }}
          src={Logo}
          alt="Dalfin Logo"
          onClick={() => {
            redirect('/facility');
          }}
        />
      </ImageWrapper>
      <div className="notification-user-profile-wrapper">
        {pathname !== '/notification' && (
          <NotificationIcon
            className="notification-logo"
            isTrue={isAnyNotification && notificationList?.unreadCount !== 0}
            onClick={() => {
              if (windowWidth < 768) {
                setIsAnyNotification(false);
                redirect('/notification');
              } else {
                setIsOpenNotification(!isOpenNotification);
              }
            }}
          />
        )}
        <UserProfileDropDown
          photo={{
            id: '',
            path: userDetails?.officialPhotoPath ?? '',
          }}
          label={userName}
          sublabel={userDetails?.designation ?? ''}
          isMobileView={isMobileView}
        />
      </div>
      {isOpenNotification && (
        <NotificationDropDownComponent
          isOpen={isOpenNotification}
          onClose={() => {
            setIsOpenNotification(false);
          }}
          setIsAnyNotification={setIsAnyNotification}
          setIsOpenNotification={setIsOpenNotification}
          notificationList={notificationList}
          onMarkAllAsRead={onMarkAllAsRead}
        />
      )}
    </Wrapper>
  );
};

export default NavBar;

const Wrapper = styled.div`
  background: ${p => p.theme.white};
  width: 100%;
  height: 47px;
  border-bottom: 1px solid ${p => p.theme.navBarBorderColor};
  display: flex;
  justify-content: space-between;
  .logo-img {
    margin: 8px 10px 25px 16px;
  }
  @media (max-width: 768px) {
    height: 44px;
    background: transparent;
    border-bottom: none !important;
  }
  .notification-user-profile-wrapper {
    display: flex;
    align-items: center;
    .notification-logo {
      cursor: pointer;
    }
  }
`;
const ImageWrapper = styled.div``;
